import apiService from '@/services/apiService'

// Reportes Operativos Fase 1 — ver
// ventax-subs-api/docs/SPEC_REPORTES_OPERATIVOS_v0.1.md

const BASE = '/api/reports'

function buildParams(filters = {}) {
  const params = {}
  for (const [key, value] of Object.entries(filters)) {
    if (value !== null && value !== undefined && value !== '') params[key] = value
  }
  return params
}

// `apiService.get(url, params, options)` — el wrapper propio de este
// proyecto, no axios crudo: el segundo argumento YA es el objeto de query
// params (el wrapper lo envuelve en `{ params }` internamente). Pasarle acá
// `{ params: ... }` como yo hacía antes quedaba doble-envuelto y la URL
// real salía como `?params[fecha_desde]=...` en vez de `?fecha_desde=...`
// — bug real encontrado con Playwright contra el navegador, no solo contra
// la API directa (ver TASKS_REPORTES_OPERATIVOS_v0.1.md, evidencia
// 2026-08-02).
async function fetchReport(path, filters) {
  const { data } = await apiService.get(`${BASE}/${path}`, buildParams(filters))
  return data
}

// Descarga el CSV real del backend (no se genera en el cliente): usa
// `responseType: 'blob'` (tercer argumento del wrapper) porque una
// descarga directa por `<a href>` no llevaría el header de autenticación
// que el interceptor de apiService agrega a cada request.
async function descargarCsv(path, filters, filenamePrefix) {
  const response = await apiService.get(
    `${BASE}/${path}`,
    { ...buildParams(filters), formato: 'csv' },
    { responseType: 'blob' }
  )
  const url = window.URL.createObjectURL(new Blob([response.data], { type: 'text/csv' }))
  const link = document.createElement('a')
  link.href = url
  link.download = `${filenamePrefix}-${Date.now()}.csv`
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(url)
}

export default {
  getVentas: (filters) => fetchReport('ventas', filters),
  getCierresCaja: (filters) => fetchReport('cierres-caja', filters),
  getProductosVendidos: (filters) => fetchReport('productos-vendidos', filters),
  // R4 — RENOMBRADO (D40, RN-81). Se llamaba `getCuentasPorCobrar` y esa
  // pregunta la responde ahora `getMorosidad`, que lee `cr_deudas`. Ésta
  // reporta el crédito de almacén heredado, que es lo que siempre reportó:
  // en producción tiene cero filas, y va a seguir teniéndolas porque D25 fija
  // que el producto sumado al cobro es siempre de contado.
  getCreditosClientes: (filters) => fetchReport('creditos-clientes', filters),
  getComprasProveedor: (filters) => fetchReport('compras-proveedor', filters),
  // R6: ventas de producto, cobros de suscripción e ingresos varios juntos.
  getIngresos: (filters) => fetchReport('ingresos', filters),

  // N1 a N4 — el negocio que somos. `cr_deudas` no estaba en ningún reporte.
  getMorosidad: (filters) => fetchReport('morosidad', filters),
  getCobranzaPeriodo: (filters) => fetchReport('cobranza-periodo', filters),
  getDeudaPorResponsable: (filters) => fetchReport('deuda-por-responsable', filters),
  getUtilidad: (filters) => fetchReport('utilidad', filters),

  descargarCsv,
}
